import React from "react";
import { BRStatistics, ResultsSports } from "./sports-menu";

export default function ResultsSportsMenu() {
	return (
		<nav className="nav--secondary nav--sports">
			<ul className="nav--secondary__menu nav--sports__menu">
				<BRStatistics />
				<ResultsSports />
			</ul>
		</nav>
	);
}
